import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  useTheme,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from '@mui/material';
import {
  updateCredential,
  CredentialInput,
  OfficialCredential
} from '../../../networkRequest/officialsService';
import { useUser } from '../../../hooks/useUser';
import SecondaryButton from '../../../components/buttons/SecondaryButton';
import PrimaryButton from '../../../components/buttons/PrimaryButton';
import DOMPurify from 'dompurify';

type CredentialDialogProps = {
  credential: OfficialCredential;
  open: boolean;
  onClose: () => void;
  onSubmit?: (formData: CredentialInput) => void;
  onError: (error: string) => void;
};

export const EditCredentialDialog = ({
  credential,
  open,
  onClose = () => {},
  onSubmit = () => {},
  onError
}: CredentialDialogProps) => {
  const { user } = useUser();
  const theme = useTheme();
  const padding = theme.spacing(4);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!user) {
      throw new Error('User not found');
    }
    const status = (e.currentTarget.elements.namedItem('status') as HTMLSelectElement)?.value;
    const sanitizedStatus = DOMPurify.sanitize(status);
    const response = await updateCredential(user.accessToken, {
      official_credential_id: credential.official_credential_id,
      status: sanitizedStatus
    });
    if (response.error) {
      onError(response.error);
    } else if (response.data) {
      onSubmit?.(response.data);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { style: { borderRadius: 8 } } }}
    >
      <form onSubmit={handleSubmit} role="form">
        <DialogTitle sx={{ padding }}>Edit Credential</DialogTitle>
        <DialogContent sx={{ padding }}>
          <Grid container spacing={3} sx={{
            padding: 1
          }}>
            <Grid size={12}>
              <FormControl fullWidth variant="outlined" required>
                <InputLabel id="credential-status-label"
                >Status</InputLabel>
                <Select
                  name="status"
                  label="Status"
                  labelId="credential-status-label"
                  id="credential-status-select"
                  defaultValue={credential.status}
                  fullWidth
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="revoked">Revoked</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding, pt: 0, mr: 1 }}>
          <SecondaryButton action={onClose}>Cancel</SecondaryButton>
          <PrimaryButton type="submit" disabled={false} loading={false}>
            Save Changes
          </PrimaryButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditCredentialDialog;
